import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { ModalController } from '@ionic/angular';
import{ApiService} from '../../services/api.service';
@Component({
  selector: 'app-buat-posting',
  templateUrl: './buat-posting.page.html',
  styleUrls: ['./buat-posting.page.scss'],
})
export class BuatPostingPage implements OnInit {

  constructor(
  private route:ActivatedRoute, 
  private modalCtrl:ModalController,
  private api:ApiService
  ) { }

  imageData:any;
  posting:any={};
  ngOnInit() {
  		
  }

  loading:boolean;
  save()
  {
  	this.posting.imageData=this.imageData;
  	this.loading=true;
  	this.api.data('eksis','post',this.posting).subscribe(data=>{
  		this.loading=false;
  		this.modalCtrl.dismiss();
  	})
  }

  closeModal()
  {
    this.modalCtrl.dismiss();
  }

}
